import { observer } from 'mobx-react-lite';
import React from 'react';
import moment from 'moment';
import { Button } from 'src/domains/common/components/button/button';
import { FileCheck, Trash2 } from 'lucide-react';

interface PropsType {
    fileName: string;
    uploadedAt: string;
    onReplace: (event: React.SyntheticEvent) => Promise<void>;
    onRemove: () => void;
}

export const FileUploadedV2 = observer((props: PropsType) => {
    const { fileName, uploadedAt, onReplace, onRemove } = props;
    const dateString = moment(parseInt(uploadedAt, 10)).format('hh:mma, Do MMMM YYYY');

    return (
        <div className='border-2 border-dashed border-gray-300 w-full flex items-center justify-center h-20 mt-2 gap-12 px-2.5'>
            <div className='flex items-center'>
                <FileCheck className='stroke-1 mr-1' />
                <div className='flex flex-col'>
                    <span className='text-sm leading-none mb-1'>{fileName}</span>
                    <span className='text-xs leading-none text-gray-400'>Uploaded {dateString}</span>
                </div>
            </div>
            <div className='flex items-center gap-2.5'>
                <Button
                    className='max-w-max'
                    variant='primary'
                    onClick={onReplace}
                >
                    Replace
                </Button>
                <div
                    className='cursor-pointer self-center text-gray-500 hover:text-gray-700'
                    onClick={onRemove}
                >
                    <Trash2 className='stroke-1' />
                </div>
            </div>
        </div>
    );
});
